/* eslint-disable no-unused-vars */
export enum ThemeStyleRadius {
  MODERN = 30,
  STANDARD = 16,
}

export enum Fonts {
  LIGHT = '300',
  REGULAR = '400',
  MEDIUM = '500',
  SEMI_BOLD = '600',
  BOLD = '700',
}
